import React, { useEffect, useState, useContext } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { ProfileContext } from "../App";
import { useAuth } from "../components/context/AuthContext";

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const { profileUpdate, setProfileUpdate } = useContext(ProfileContext);
  const [image, setImage] = useState("");
  const [name, setName] = useState("");
  const [group_name, setGroupName] = useState("");
  const location = useLocation(); // Hook to get the current route
  const navigate = useNavigate();

  const { user, logout, isAuthenticated, loading } = useAuth();
  useEffect(() => {
    if (!loading && !isAuthenticated && location.pathname !== "/sign-in") {
      navigate("/sign-in");
    }
  }, [isAuthenticated, location.pathname, navigate, loading]);

  useEffect(() => {
    // Function to handle dropdown clicks
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link",
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    // Function to open submenu based on current route
    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
          }
        });
      });
    };

    // Open the submenu that contains the open route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const handleLogout = async () => {
    await logout();
    navigate("/sign-in");
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/" className="sidebar-logo">
            <img
              src="/assets/images/auto-pro-logo.png"
              alt="site logo"
              className="light-logo"
            />
            <img
              src="/assets/images/auto-pro-logo.png"
              alt="site logo"
              className="dark-logo"
            />
            <img
              src="/assets/images/auto-pro-fav.png"
              alt="site logo"
              className="logo-icon"
            />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            <>
              {/* <li className="dropdown">
                  <Link to="#">
                    <Icon
                      icon="material-symbols:dashboard-outline"
                      className="menu-icon"
                    />
                    <span>Dashboard</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li>
                      <NavLink
                        to="/"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                        Statistics
                      </NavLink>
                    </li>
               
                  </ul>
                </li> */}

              {/* autoprohub menu starts */}
              <li className="sidebar-menu-group-title">Users</li>
              <li>
                <NavLink
                  to="/all-users"
                  className={(navData) =>
                    navData.isActive ||
                    location.pathname === "/add-user" ||
                    location.pathname === "/" ||
                    location.pathname.includes("edit-user")
                      ? "active-page"
                      : ""
                  }
                >
                  <Icon icon="fluent:people-24-regular" className="menu-icon" />

                  <span>Manage Users</span>
                </NavLink>
              </li>
              <li className="sidebar-menu-group-title">Garage</li>
              <li>
                <NavLink
                  to="/all-garages"
                  className={(navData) =>
                    navData.isActive ||
                    location.pathname === "/add-garage" ||
                    location.pathname.includes("edit-garage") ||
                    location.pathname.includes("garage-details")
                      ? "active-page"
                      : ""
                  }
                >
                  <Icon icon="mdi:garage" className="menu-icon" />

                  <span>Manage Garages</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/all-bookings"
                  className={(navData) =>
                    navData.isActive ||
                    location.pathname === "/add-booking" ||
                    location.pathname.includes("edit-booking") ||
                    location.pathname.includes("booking-details")
                      ? "active-page"
                      : ""
                  }
                >
                  <Icon icon="mdi:calendar-check" className="menu-icon" />

                  <span>Manage Booking</span>
                </NavLink>
              </li>
              {/* <li>
                  <NavLink
                    to="/all-vehicles"
                    className={(navData) =>
                      navData.isActive ||
                      location.pathname === "/add-vehicle" ||
                      location.pathname.includes("edit-vehicle")
                        ? "active-page"
                        : ""
                    }
                  >
                  <Icon icon="mdi:car" className="menu-icon" />


                    <span>Manage Vehicle</span>
                  </NavLink>
                </li> */}
              <li>
                <NavLink
                  to="/service-catalog"
                  className={(navData) =>
                    navData.isActive ||
                    location.pathname === "/add-service" ||
                    location.pathname.includes("edit-service")
                      ? "active-page"
                      : ""
                  }
                >
                  <Icon icon="mdi:wrench" className="menu-icon" />

                  <span>Manage Services</span>
                </NavLink>
              </li>
              <li className="sidebar-menu-group-title">Reviews</li>
              <li>
                <NavLink
                  to="/garage-reviews"
                  className={(navData) =>
                    navData.isActive ||
                    location.pathname.startsWith("/garage-reviews-detail")
                      ? "active-page"
                      : ""
                  }
                >
                  <Icon
                    icon="mdi:comment-check-outline"
                    className="menu-icon"
                  />
                  <span>Review Moderation</span>
                </NavLink>
              </li>
              <li className="sidebar-menu-group-title">Communications</li>

              <li>
                <NavLink
                  to="/announcements"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:bullhorn-outline" className="menu-icon" />
                  <span>Announcements</span>
                </NavLink>
              </li>

              {/* autoprohub menu ends */}
            </>
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type="button"
                  className="sidebar-mobile-toggle"
                >
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button>
                {/* <form className="navbar-search">
                  <input type="text" name="search" placeholder="Search" />
                  <Icon icon="ion:search-outline" className="icon" />
                </form> */}
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                {/* ThemeToggleButton */}

                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    {user?.image_url ? (
                      <img
                        src={user.image_url}
                        alt="user"
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                          e.currentTarget.nextSibling.style.display = "flex";
                        }}
                        className="w-50-px h-50-px object-fit-cover rounded-circle border border-primary shadow-sm"
                      />
                    ) : (
                      <div className="w-50-px h-50-px rounded-circle border border-primary shadow-sm d-flex align-items-center justify-content-center bg-primary text-white fw-semibold">
                        {user?.fullName?.trim()?.charAt(0)?.toUpperCase() ||
                          "U"}
                      </div>
                    )}
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          {user?.fullName || "User"}
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">
                          Admin
                        </span>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon
                          icon="radix-icons:cross-1"
                          className="icon text-xl"
                        />
                      </button>
                    </div>
                    <ul className="to-top-list">
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="/view-profile"
                        >
                          <Icon
                            icon="solar:user-linear"
                            className="icon text-xl"
                          />{" "}
                          My Profile
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="/email"
                        >
                          <Icon
                            icon="tabler:message-check"
                            className="icon text-xl"
                          />{" "}
                          Inbox
                        </Link>
                      </li> */}
                      {/* <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="/company"
                        >
                          <Icon
                            icon="icon-park-outline:setting-two"
                            className="icon text-xl"
                          />
                          Setting
                        </Link>
                      </li> */}
                      <li>
                        <button
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          onClick={handleLogout}
                        >
                          <Icon icon="lucide:power" className="icon text-xl" />{" "}
                          Log Out
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-end justify-content-end">
            <div className="col-auto">
              <p className="mb-0">
                © 2025 AutoProHub Admin. All Rights Reserved.
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
